module.exports = __webpack_public_path__ + "img/ic-add.a93563f8.svg";